const BREAKPOINTS = {
    mobile : 576,
    tablet : 768,
    desktop : 992,
    big_desktop : 1200,
    big_screem : 1400
};

export default BREAKPOINTS;